module.exports = __webpack_public_path__ + "img/api-plus-circle.62cd9ccc.svg";